export default {
  companyname: {
    presence: { allowEmpty: false, message: 'is required' }
  }
};
